import type { EntityData } from '@adornis/baseql/entities/types.js';
import { acss } from '@adornis/chemistry/directives/acss.js';
import '@adornis/chemistry/elements/components/x-flex.js';
import type { GenericFieldFormController } from '@adornis/cms/client/generic-field-formcontroller.js';
import '@adornis/internationalization/client/x-tel-input.js';
import type { TranslationController } from '@adornis/translation-core/client/translation-controller.js';
import { html } from 'lit';
import type { BHTranslationDictionary } from '../../translations/translation.js';
import type { RegistrationUserDataPlugin } from '../plugin-types.js';
import { type DemoStammdaten } from '../stammdaten/demo-stammdaten-plugin.js';

type stammdatenKeys = keyof EntityData<DemoStammdaten>;

export const demoRegistrationUserDataPlugin: RegistrationUserDataPlugin<DemoStammdaten> = {
  id: 'registration::user-data::demo',
  type: 'registration::user-data',
  render: (
    stammdatenController: GenericFieldFormController<DemoStammdaten>,
    translationController: TranslationController<BHTranslationDictionary>,
  ) => {
    const genericFieldOption = (fieldName: string) =>
      ({
        placeholder: translationController.translate('demo', 'field', fieldName as any) as string,
        placeholderMode: 'static-floating',
      } as const);

    return html`
      <x-flex space="lg">
        <x-flex space="sm">
          <x-tel-input
            placeholder=${translationController.translate('demo', 'field', 'phoneNumber')}
            ${stammdatenController.field('phoneNumber')}
          ></x-tel-input>

          ${(['salutation', 'title'] as stammdatenKeys[]).map(fieldName =>
            stammdatenController.genericField([fieldName], genericFieldOption(fieldName)),
          )}
        </x-flex>
        <x-flex space="md">
          <tr-h4> Rechnungsadresse </tr-h4>
          <x-flex space="sm">
            ${stammdatenController.genericField(
              ['address', 'streetAndHousenumber'],
              genericFieldOption('streetAndHousenumber'),
            )}
            <x-flex horizontal space="sm" ${acss({ '*:last-child': { flex: '1' } })}>
              ${stammdatenController.genericField(['address', 'zipCity', 'zip'], genericFieldOption('zip'))}
              ${stammdatenController.genericField(['address', 'zipCity', 'city'], genericFieldOption('city'))}
            </x-flex>
          </x-flex>
        </x-flex>
      </x-flex>
    `;
  },
};
